export function sortByLowestRank<Sortable extends {rank: number}>(a: Sortable, b: Sortable): number {
  return a.rank - b.rank
}
